<template>
  <insight :insight="insight"
           image-name="tomer-insight.png"
           button-text="ספרו לי עוד"
           :button-action="buttonAction">
    <template v-slot:insight-text>
      <div>
        <span v-if="positiveCashflows === 5">5 תזרימים חיוביים ברצף, שאפו!</span>
        <span v-else>{{positiveCashflows}} תזרימים חיוביים ב־5 חודשים האחרונים, שאפו!</span>
        <span>עם המומחים שלנו לייעוץ כלכלי, אפשר</span>
        <span class="ri-font-weight-bold">להתחיל לחשוב על העתיד.</span>
      </div>
    </template>
  </insight>
</template>

<script>
import Insight from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/insights/components/Insight';
import { mapActions } from 'vuex';
import Segment from '@/Segment';
import router from '@/router';

export default {
  name: 'AdvisoryInsight',
  components: {
    Insight,
  },
  props: {
    insight: { type: Object },
  },
  created() {
    Segment.trackUserGot('AdvisoryInsight', { variant: 'old', positiveCashflowsNum: this.positiveCashflows });
  },
  computed: {
    positiveCashflows() {
      return this.insight.positiveCashflows;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    async buttonAction() {
      Segment.trackUserInteraction('AdvisoryInsight_ButtonClicked');
      router.push({ path: '/advisory-plan' });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
